import React, {useState} from "react";
import Modal from "react-responsive-modal";
import ModalAddSchool from "root/Modals/ModalAddSchool";

export const AddSchoolModalMode = {
    CREATE : 'create',
    EDIT: 'edit'
};

const useModalAddSchool= () =>
{
    const [dialog, setDialog]  = useState ( { openState: false, provider_id: null, onSaveCompleted: null, mode: null })   ;

    const onClick = ( provider_id, onCompleteFunction, mode ) =>
    {
        setDialog ({ openState: true, provider_id: provider_id, onSaveCompleted: onCompleteFunction, mode: mode });
    }

    const onCloseModal = () =>
    {
        // Tell the parent we're done
        if ( dialog.onSaveCompleted != null )
        {
            dialog.onSaveCompleted('cancel') ;
        }

        setDialog ({ openState: false, provider_id: null, onSaveCompleted: null, mode: null });
    };

    const onSaveComplete = () =>
    {
        // Tell the parent we're done
        if ( dialog.onSaveCompleted != null )
        {
            dialog.onSaveCompleted('saved') ;
        }

        // Close the dialog
        setDialog ({ openState: false, provider_id: null, onSaveCompleted: null, mode: null });

    };

    const render = () =>
    {
        return (
            <Modal center focusTrapped={false} open={dialog.openState} closeOnOverlayClick={false} onClose={onCloseModal}>
                <ModalAddSchool onSaveCompleted={onSaveComplete} onClose={onCloseModal} provider_id={dialog.provider_id} params={dialog} mode={dialog.mode} />
            </Modal>
        )
    }

    return [ render, onClick ] ;
}

export default useModalAddSchool ;
